import { DialogContent } from "@mui/material"
import Box from "@mui/material/Box"
import React, { useEffect } from "react"
import { GAME_URL } from "../../../../constants/constants"

const GAME_ORIGIN = "https://harveymonsterteam.com"

const GameDialog = ({
  tournamentId,
  user,
  closeDialog,
  onGameFinished,
  width = 1285,
  height = 725,
}) => {
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== GAME_ORIGIN) {
        return
      }

      if (event.data?.type !== "TDZ_GAME_FINISHED") {
        return
      }

      closeDialog()

      setTimeout(() => {
        onGameFinished?.(event.data.payload)
      }, 0)
    }

    window.addEventListener("message", handleMessage)

    return () => {
      window.removeEventListener("message", handleMessage)
    }
  }, [closeDialog, onGameFinished])

  return (
    <Box
      sx={{
        width,
        height,
        textAlign: "center",
        border: "1px solid rgba(198, 146, 76, 0.25)",
        borderRadius: 1,
      }}
    >
      <DialogContent sx={{ p: 0, m: 0 }}>
        <Box
          component="iframe"
          src={`${GAME_URL}/?session=${user?.sessionToken ?? ""}&tournament_id=${tournamentId}`}
          title="Zombie TD Demo"
          sx={{
            display: "block",
            width: "1280px",
            height: "720px",
            border: 0,
            background: "#000",
            m: "0 auto",
          }}
          allow="fullscreen; autoplay; clipboard-read; clipboard-write"
          allowFullScreen
        />
      </DialogContent>
    </Box>
  )
}
export default GameDialog
